module.exports = __webpack_public_path__ + "static/media/Anim_03.232341e5.fbx";